const messages = {
    buttons: {
        productBrochures: "Descobrir",
    },
    index: {
        title: "INFORMAÇÃO DO PRODUTO",
        description: "Descarregue aqui os últimos folhetos e panfletos dos nossos pneus Bridgestone e Firestone.",
        categories: {
            productBrochures: {
                title: "Folhetos de produtos",
                description: "Folhetos das gamas de pneus Bridgestone e Firestone",
            },
            bDrive: {
              title: "Imagens de produtos",
              description: "Pode encontrar imagens atualizadas para download no nosso portal B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

